import { FactoryProvider } from '@angular/core';
import { PDAuthService, User } from 'pdauth';
import { Observable } from 'rxjs';

type IAuthenticationServiceConstructor = new () => IAuthenticationService;
interface IAuthenticationService {
    user: Observable<User>;
    permissions: Observable<string[]>;

    GetCurrentUser: () => Observable<User>;
    HasPermission: (permission: string) => boolean;
    HasAnyPermission: (...permissions: string[]) => boolean;
    HasAllPermissions: (...permissions: string[]) => boolean;
    // TODO: User interface for return values, Additional methods and properties
}

class AuthenticationService implements IAuthenticationService {
    constructor(private readonly pdauth: PDAuthService) {
        this.user = pdauth.getLoggedInUser();
        //this.user.subscribe(user => this._user = user);

        this.permissions = this.pdauth.getLoggedInUserPermissions();
        //this.permissions.subscribe(permissions => this._permissions = permissions);
    }

    user: Observable<User> = null;
    //private _user: User;

    permissions: Observable<string[]> = null;
    //private _permissions: string[];

    GetCurrentUser() {
        if (!this.user) {
            this.user = this.pdauth.getLoggedInUser();
        }
        return this.user;
    }
    HasPermission(permission: string) { return this.pdauth.hasPermission(permission); }
    HasAnyPermission(...permissions: string[]) { return this.pdauth.hasAnyPermission(permissions); }
    HasAllPermissions(...permissions: string[]) { return this.pdauth.hasAllPermissions(permissions); }
}

const AuthenticationServiceProvider: FactoryProvider = {
    deps: [PDAuthService],
    provide: 'authenticationService',
    useFactory: (pdauth: PDAuthService) =>
        window.AuthenticationService ? new window.AuthenticationService() : new AuthenticationService(pdauth)
};

export { AuthenticationServiceProvider, IAuthenticationService, IAuthenticationServiceConstructor };
